export default __webpack_public_path__ + "static/media/3.7970d5d7.jpeg";